// extracted by mini-css-extract-plugin
module.exports = {"button":"button__2MD1b","roundedButton":"roundedButton__2lT1j"};